/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Wizard from 'shared/ui/components/Wizard.vue';
import GeneralStep from './General.vue';
import InteractivityStep from './Interactivity.vue';
import DesignStep from './Design.vue';
import RegistrationPageStep from './RegistrationPage.vue';
import EventProgress from 'ui/components/modals/EventProgress.vue';

// Utils
import moment from 'moment-timezone';
import { get } from 'lodash';

// Model
import { Webinar, InteractivityOptions } from 'libs/models/webinar/webinar';

// Mixins
import creationJobManager from 'ui/mixins/webinars/creation-job-manager';

const __vue_script__ = {
    name: 'CreateWebinarFromScratchModal',

    components: {
        Wizard,
        GeneralStep,
        InteractivityStep,
        DesignStep,
        RegistrationPageStep,
        EventProgress
    },

    mixins: [creationJobManager],

    props: {
        user: {
            type: Object,
            required: true,
        },

        templates: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        const infoMessage = this.templates.length ? null : this.$t('webinars.creation.no_template_found');
        return {
            wizardCompleted: false,
            steps: [
                {
                    title: 'webinars.creation.steps.general',
                    component: GeneralStep,
                    modalContentStyle: 'narrow',
                    props: {
                        user: this.user,
                        infoMessage: infoMessage
                    }
                },
                {
                    title: 'webinars.creation.steps.interactivity',
                    component: InteractivityStep,
                    modalContentStyle: 'narrow'
                },
                {
                    title: 'webinars.creation.steps.design',
                    component: DesignStep,
                    modalContentStyle: 'narrow'
                },
                {
                    title: 'webinars.creation.steps.registration_page',
                    component: RegistrationPageStep,
                    nextLabel: 'webinars.creation.last_step',
                    modalContentStyle: 'narrow'
                }
            ],
            initialData: setupWebinar()
        };
    },

    methods: {
        async submitForm(formData) {
            this.wizardCompleted = true;

            const formDataInteractivity = this.getInteractivityFromData(formData);
            const data = {
                orgId: formData.orgId,
                brandedApp: formData.branded_app,
                pathName: formData.path_name,
                startAt: moment(formData.startTime).unix(),
                endAt: moment(formData.startTime).add(formData.duration, 'minutes').unix(),
                name: formData.name,
                timezone: formData.timezone,
                serverGroup: formData.serversLocation,
                category: formData.category,
                categories: formData.categories,
                webinarSpecific: {
                    interactivity: formDataInteractivity,
                    description: formData.description,
                    brandColor: formData.brandColor,
                    formFields: formData.registrationPageFields
                }
            };

            let files = {};
            if (formData.background) {
                files.background = formData.background;
            }
            if (formData.icon) {
                files.icon = formData.icon;
            }
            if (formData.banner) {
                files.banner = formData.banner;
            }

            const organization = this.user.orgs.find(o => o._id = formData.orgId);
            const categoryEnabled = get(organization, 'workspace_defaults.enable_category', false);

            if (categoryEnabled) {
                data.category = formData.category;
                data.categories = formData.categories;
            }

            await this.startCreation(data, files);
        }
    }
};

function setupWebinar() {
    const interactivityOptions = new InteractivityOptions({
        clappingEnabled: true,
        qnaEnabled: true,
        pollsEnabled: true,
        qnaModerationEnabled: true,
        qnaAnonymousEnabled: true
    });

    return new Webinar({
        duration: 60,
        brandColor: '#3185FC',
        interactivityOptions
    });
}


/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-webinar-from-scratch"},[(!_vm.wizardCompleted)?_c('wizard',{attrs:{"initial-data":_vm.initialData,"steps":_vm.steps,"target":"_blank"},on:{"wizard:completed":_vm.submitForm}},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('h1',[_vm._v(_vm._s(_vm.$t('webinars.creation.title')))])]):_vm._e(),(_vm.wizardCompleted && !_vm.error)?_c('event-progress',{attrs:{"hide-cards":"hide-cards","progress":_vm.progress,"title":_vm.$t('webinars.creating_webinar')}}):_vm._e(),(_vm.error)?_c('div',{staticClass:"errors modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('general.something_wrong')))])]),_c('div',{staticClass:"modal-body"},[(_vm.error.length)?_c('p',[_vm._v(_vm._s(_vm.$t('general.error_occurred'))+":")]):_vm._e(),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.error))}}),_c('p',[_vm._v(_vm._s(_vm.$t('general.try_later')))])]),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions",attrs:{"slot":"bottom"},slot:"bottom"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.close')))])])])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CreateFromScratchModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__